const styles = (theme) => ({
    dialog: {
      width: 470,
      backgroundColor: theme.ModalBGColor,
    },
    dialogContent : {
      padding:0
    },
    stopName: {
      color: theme.HeaderSelectedText,
      fontSize: theme.headerTextFontSize,
      fontWeight: 600,
    },
    divider: {
      borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    },
    stopAddress: {
      color: theme.subHeaderTextColor,
      fontSize: theme.textFontSize,
      fontWeight: 400,
    },
    deliveryBillsHeaderText: {
      color: theme.TextColor,
    },
    dialogWrapper: {},
    confirmDialogContent:{
      display:"flex",
      flexDirection:"column"
    },
    processDeliveryContent : {
        padding : "0 24px 24px",
    }
  });
    
    export default styles;